import React, {Component} from 'react';
import { connect } from 'react-redux';
import Header from '../base/header';
import Stats from './stats';
import Prices from './prices';
import Desvios from './desvios'
import {fetchGroups} from "../../actions/groups_actions";

class Dashboard extends Component {

    constructor(props) {
        super(props);
        this.state = {
            clusters: [
                {
                    active: false,
                    bocas: [{
                        active: false
                    },{
                        active: false
                    },{
                        active: false
                    }]
                },
                {
                    active: false,
                    bocas: [{
                        active: false
                    }]
                }
            ],
            desvioId:null
        };

        this.openDesvio = this.openDesvio.bind(this);
    }

    componentDidMount(){
        this.props.fetchGroups();
    }

    openDesvio(id){
        let _self = this;
        let _state = _self.state;
        _self.setState({
          desvioId: null
        }, function() {
          _state.desvioId = id;
          _self.setState(_state);  
        });
        
    }

    render(){
        let _self = this;
        return (
            <div>
                <Header history={_self.props.history} />
                <section className="dashboard">
                    <div className="container-fluid">
                        <Stats />
                        <Prices openDesvio={_self.openDesvio} />
                        <Desvios desvioId={_self.state.desvioId} />
                    </div>
                </section>
            </div>
        );
    }

}

const mapStateToProps = (state) => {
    return {
        user: state.user
    }
}

export default connect(mapStateToProps,{fetchGroups})(Dashboard);


// WEBPACK FOOTER //
// ./src/containers/dashboard/dashboard.js